import type {
  AuthSessionDto,
  LoginRequestDto,
  LoginResponseDto,
  PasswordResetConfirmDto,
  PasswordResetRequestDto,
  PasswordResetRequestedDto,
  PasswordResetVerifiedDto,
  PasswordResetVerifyDto,
  SelectAccountRequestDto,
} from '../../domain/contracts/api.contracts';
import { apiClient } from './apiClient';

/** E01 — POST /auth/login. A person with several apartment accounts gets the picker (no session) — BD-30. */
export async function postLogin(body: LoginRequestDto): Promise<LoginResponseDto> {
  const { data } = await apiClient.post<LoginResponseDto>('/auth/login', body);
  return data;
}

/** E27 — POST /auth/select-account: complete a multi-account login with the chosen apartmentId. */
export async function postSelectAccount(body: SelectAccountRequestDto): Promise<AuthSessionDto> {
  const { data } = await apiClient.post<AuthSessionDto>('/auth/select-account', body);
  return data;
}

/** E03 — POST /auth/logout (204) */
export async function postLogout(): Promise<void> {
  await apiClient.post('/auth/logout');
}

/** E30 — POST /auth/password-reset/request (202). Same body for every well-formed phone. */
export async function postPasswordResetRequest(body: PasswordResetRequestDto): Promise<PasswordResetRequestedDto> {
  const { data } = await apiClient.post<PasswordResetRequestedDto>('/auth/password-reset/request', body);
  return data;
}

/** E31 — POST /auth/password-reset/verify: exchange the SMS code for a single-use reset token. */
export async function postPasswordResetVerify(body: PasswordResetVerifyDto): Promise<PasswordResetVerifiedDto> {
  const { data } = await apiClient.post<PasswordResetVerifiedDto>('/auth/password-reset/verify', body);
  return data;
}

/** E32 — POST /auth/password-reset/confirm (204). No session is created. */
export async function postPasswordResetConfirm(body: PasswordResetConfirmDto): Promise<void> {
  await apiClient.post('/auth/password-reset/confirm', body);
}
